import React, { Fragment, Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Highlight from 'LegacyWeployDesignLanguage/Highlight';

const ShowMoreLessLink = styled.a`
  display: inline-block;
  padding-top: 0;
  padding-left: ${props => props.theme.space.single};
  margin-bottom: ${props => props.theme.space.single};
  text-decoration: underline;
  font-weight: 700;
  cursor: pointer;
  color: ${props => props.theme.colors.weployBlue};
`;

const StyledTitle = styled.div`
  color: ${props => props.theme.colors.text.primary};
  ${props => props.theme.typography.subtitle1};
`;

class List extends Component {
  constructor(props) {
    super(props);

    this.state = {
      itemsExpanded: !props.maxVisible,
    };
  }

  render() {
    const {
      items,
      title,
      searchTerms,
      maxVisible,
    } = this.props;
    const { itemsExpanded } = this.state;

    if (items && items.length) {
      const itemsToDisplay = (!maxVisible || itemsExpanded)
        ? items
        : [...items].slice(0, maxVisible);

      return (
        <Fragment>
          { title && <StyledTitle>{title}</StyledTitle> }
          <ul>
            { itemsToDisplay.map(item => (
              <li key={item}>
                <Highlight
                  searchTerms={searchTerms}
                  text={item}
                />
              </li>
              ))}
          </ul>
          { maxVisible && (items.length > maxVisible) &&
            <ShowMoreLessLink onClick={() => this.setState({ itemsExpanded: !itemsExpanded })}>
              {`Show ${itemsExpanded ? 'less' : 'more'}`}
            </ShowMoreLessLink>
          }
        </Fragment>
      );
    }

    return null;
  }
}

List.propTypes = {
  title: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.string),
  searchTerms: PropTypes.arrayOf(PropTypes.string),
  maxVisible: PropTypes.number,
};

List.defaultProps = {
  title: '',
  items: [],
  searchTerms: [],
  maxVisible: null,
};

export default List;
